import type { ItemFinderOutputV1 } from '../../target/generated/sdk/model/ItemFinderOutputV1';

export const createItemFinderOutputV1 = (_count: number) =>
  ({
    lastRunAt: '2024-01-01T00:00:00Z',
    type: 'ItemFinder',
  }) satisfies Partial<ItemFinderOutputV1>;
